/**
 * Column IDs for the Preorders table.
 * Used to identify columns in the table configuration and cell rendering.
 */
export const PREORDERS_TABLE_COLUMN_ID = {
	BUYER: 'buyer',
	STATUS: 'status',
	VEHICLE: 'vehicle',
	ACCESSORIES: 'accessories',
	EST_RETAIL_PRICE: 'estRetailPrice',
	STATE: 'state',
	PREORDER_AMOUNT: 'preorderAmount',
	DATE_PURCHASED: 'datePurchased',
	ACTIONS: 'actions',
} as const;

/** Union type of preorders table column ID values. */
export type PreordersTableColumnId = (typeof PREORDERS_TABLE_COLUMN_ID)[keyof typeof PREORDERS_TABLE_COLUMN_ID];
